import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form, Radio, Popconfirm } from "antd";
import { useI18n, useUpsell } from "../../../../../contexts";
const FormContentBlockerFieldVisualDownloadThumbnail = ()=>{
    const { __ } = useI18n();
    const { isPro } = useUpsell();
    return isPro && /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, nextValues)=>prevValues.visualDownloadThumbnail !== nextValues.visualDownloadThumbnail || prevValues.isVisual !== nextValues.isVisual || prevValues.visualType !== nextValues.visualType,
        children: (param)=>{
            let { getFieldValue, setFieldsValue } = param;
            const visualDownloadThumbnail = getFieldValue("visualDownloadThumbnail");
            const isVisual = getFieldValue("isVisual");
            const visualType = getFieldValue("visualType");
            return !!isVisual && visualType !== "default" && /*#__PURE__*/ _jsx(_Fragment, {
                children: /*#__PURE__*/ _jsxs(Form.Item, {
                    label: __("Automatic preview image"),
                    children: [
                        /*#__PURE__*/ _jsx(Form.Item, {
                            noStyle: true,
                            name: "visualDownloadThumbnail",
                            required: true,
                            rules: [
                                {
                                    required: true,
                                    type: "boolean",
                                    message: __("Please choose an option!")
                                }
                            ],
                            children: /*#__PURE__*/ _jsxs(Radio.Group, {
                                style: {
                                    display: visualDownloadThumbnail ? undefined : "none"
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(Radio.Button, {
                                        value: true,
                                        children: __("Download preview image and serve locally")
                                    }),
                                    /*#__PURE__*/ _jsx(Radio.Button, {
                                        value: false,
                                        children: __("Image from media library")
                                    })
                                ]
                            })
                        }),
                        !visualDownloadThumbnail && /*#__PURE__*/ _jsxs(Radio.Group, {
                            value: visualDownloadThumbnail,
                            children: [
                                /*#__PURE__*/ _jsx(Popconfirm, {
                                    title: __("I confirm that I have the required rights to embedded content and its thumbnails can be copied to my servers without e.g. copyright infringement."),
                                    cancelText: __("Cancel"),
                                    okText: __("Activate now"),
                                    overlayStyle: {
                                        maxWidth: 450
                                    },
                                    onCancel: ()=>setFieldsValue({
                                            visualDownloadThumbnail: false
                                        }),
                                    onConfirm: ()=>setFieldsValue({
                                            visualDownloadThumbnail: true
                                        }),
                                    placement: "bottomLeft",
                                    children: /*#__PURE__*/ _jsx(Radio.Button, {
                                        value: true,
                                        children: __("Download preview image and serve locally")
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Radio.Button, {
                                    value: false,
                                    onClick: ()=>setFieldsValue({
                                            visualDownloadThumbnail: false
                                        }),
                                    children: __("Image from media library")
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "description",
                            children: __("If you block an external URL, this option will try to download an image for this URL using different mechanisms (oEmbed, OpenGraph, ...), saves it locally and use it as background image.")
                        })
                    ]
                })
            });
        }
    });
};
export { FormContentBlockerFieldVisualDownloadThumbnail };
